import SectionList from "./SectionList";
import SectionCreate from "./SectionCreate";
import SectionEdit from "./SectionEdit";
import SectionShow from "./SectionShow";
import SectionIcon from "@mui/icons-material/ViewStream";

const sections = {
  list: SectionList,
  create: SectionCreate,
  edit: SectionEdit,
  show: SectionShow,
  icon: SectionIcon,
};

export default sections;
